import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/Search.css';
import ls from 'local-storage'
import axios from 'axios';
import Retry from "./Retry";
import Products from "./Products";
import AppBody from "./AppBody";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import update from 'react-addons-update';
class Search extends React.Component{
    list =[];
    categories = [];
    types = [];
    sorts = [];
    hasMoreProductToLoad = true;
    content = document.getElementsByClassName("content")[0];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            page: 1,
            retry: false,
            error: false,
            error_text: "",
            url:"",
            search:"",
            shop_category:[],
            //search_type:"product",
            type:"product",
            sort:"max-view",
            loading: false,
            products: [],
            categories:[],
            category_open:false,
            type_open:false,
            sort_open:false,
        };
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }
    componentDidMount = () => {
        this.content = document.getElementsByClassName("content")[0];
        this.content.addEventListener("scroll",this.handleScroll,false);
        this.types = [
            new Type("محصولات","product"),
            new Type("فروشگاه","store"),
            new Type("خدماتی","service"),
            new Type("دیوار","divar"),
        ];
        this.sorts = [
            new Type("قیمت از کم به زیاد","inexpensive"),
            new Type("قیمت از زیاد به کم","expensive"),
            new Type("پربازدیدترین","max-view"),
            new Type("جدیدترین","new"),
        ];
        this.loadCategories();
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );
        return (
            <AppBody  loading={this.state.loading} name={"جست و جو"} type={" alice"}>
                <div id={"searchBar"}>
                    <img onClick={()=>{this.setState({sort_open:true})}} className={"searchIcon"} src={`${process.env.PUBLIC_URL}/assets/images/sort.png`}/>
                    <img onClick={()=>{this.setState({type_open:true})}} className={"searchIcon"} src={`${process.env.PUBLIC_URL}/assets/images/searchtype.png`}/>
                    <img onClick={()=>{this.setState({category_open:true})}} className={"searchIcon"} src={`${process.env.PUBLIC_URL}/assets/images/list.png`}/>
                    <input onKeyDown={this._handleKeyDown} placeholder={"نام محصول"} className={"searchInput"} value={this.state.search} onChange={this.handleSearchText}/>
                    <img onClick={this.Search} className={"searchIcon"} src={`${process.env.PUBLIC_URL}/assets/images/search.png`}/>
                </div>
                <div id={"searchProducts"}>
                    <Products products={this.state.products}/>
                </div>
                {this.renderCategories()}
                {this.renderTypes()}
                {this.renderSorts()}
            </AppBody>
        );
    }
    renderCategories=()=>{
        return (
            <Dialog open={this.state.category_open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">دسته بندی فروشگاه ها</DialogTitle>
                <DialogContent>
                    {this.state.categories.map((category,index)=>{
                        return (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={category.checked}
                                        onChange={(e)=>{this.changeState(e,index)}}
                                        name="shopCategory"
                                        color="primary"
                                    />
                                }
                                label={category.text}
                            />
                        );
                    })}
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{this.handleClose();this.Search()}} color="primary">
                        تایید
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };
    renderTypes=()=>{
        return (
            <Dialog open={this.state.type_open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">جست و جو در</DialogTitle>
                <DialogContent>
                    <FormControl component="fieldset">
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.type} onChange={this.changeTypeState}>
                            {this.types.map((type)=>{
                                return (
                                    <FormControlLabel value={type.value} control={<Radio />} label={type.name} />
                                );
                            })}
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{this.handleClose();this.Search()}} color="primary">
                        تایید
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };
    renderSorts=()=>{
        return (
            <Dialog open={this.state.sort_open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">جست و جو در</DialogTitle>
                <DialogContent>
                    <FormControl component="fieldset">
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.sort} onChange={this.changeSortState}>
                            {this.sorts.map((type)=>{
                                return (
                                    <FormControlLabel value={type.value} control={<Radio />} label={type.name} />
                                );
                            })}
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{this.handleClose();this.Search()}} color="primary">
                        تایید
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };
    handleSearchText = (event)=>{
        this.setState({search:event.target.value});
    };
    changeTypeState=(event)=>{
        this.setState({type:event.target.value})
    };
    changeSortState=(event)=>{
        this.setState({sort:event.target.value})
    };
    _handleKeyDown = (e) =>{
        if (e.key === 'Enter') {
            this.Search();
        }
    };
    handleRedirect(menu){
        switch (menu.menuen) {
            case "store":
                this.setState({redirect:true,url:"/categories"});
                break;
            case "new_products":
                this.setState({redirect:true,url:"/new_products"});
                break;
            default :
                break;
        }
    }
    Search=()=> {
        if (this.state.search.length < 2) {
            alert("حداقل حروف وارد شده نباید کمتر از 2 حرف باشد");
            return;
        }
        this.setState({
            products:[],
            page:1
        },()=>{
            this.getSearchResult();
        });
    };
    getSearchResult(){
        this.setState({loading: true});
        let shopCategories = [];
        for (let i = 0; i < this.state.categories.length; i++){
            if (this.state.categories[i].checked)
                shopCategories.push(this.state.categories[i].id);
        }
        let data = {
            keyword:this.state.search,
            type:this.state.sort,
            page:this.state.page,
            search_type:this.state.type,
            shop_category:JSON.stringify(shopCategories),
            token:ls.get("token"),
        };
        axios.post(urls.baseUrl+urls.search,data)
            .then(res => {
                console.log("products : ",res.data);
                if(res.data.code == 200){
                    if(res.data.product_list.length === 0)
                        this.hasMoreProductToLoad = false;
                    else
                        this.hasMoreProductToLoad = true;

                    this.setState({
                        products:[...this.state.products, ...res.data.product_list],
                        loading:false},()=>{
                        this.content.addEventListener("scroll",this.handleScroll,false);
                    });
                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,loading:false},()=>{
                    this.content.addEventListener("scroll",this.handleScroll,false);
                });
            });
    }

    loadCategories(){
        this.setState({loading: true});

        let data = {
            token:ls.get("token"),
        };

        axios.get(urls.baseUrl+urls.getCategoriesForSearch+"?token="+ls.get("token"))
            .then(res => {
                console.log("products : ",res.data);
                let categories = [];
                if(res.data.code == 200){
                    categories = res.data.categories.map(function (category){
                       return new Category(category.id, category.cat_name, true);
                    });
                    this.setState({
                        categories:categories,
                        loading:false});
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,loading:false});
            });
    }
    handleScroll = (event) => {
        if(!this.hasMoreProductToLoad){
            event.target.removeEventListener("scroll", this.handleScroll);
            return;
        }

        if(event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight < 2 && !this.isLoadingMore){
            event.target.removeEventListener("scroll", this.handleScroll);

            this.setState({page:this.state.page+1},() => {
                this.getSearchResult();
            })
        }
    };
    handleClose  = () => {
        this.setState({
            open:false,
            category_open:false,
            type_open:false,
            sort_open:false,
        })
    };
    changeState =(event,index)=>{
        if(index == 0)
            this.changeWholeCategories(event);
        this.setState({
            categories: update(this.state.categories, {[index]: {checked: {$set: event.target.checked}}})
        });
    };
    changeWholeCategories =(event)=>{
        for(let i = 0 ; i< this.categories.length; i++)
            this.categories[i].checked = event.target.checked;

        this.setState({categories:this.categories});
    }
}

class Category {
    checked;
    id;
    text;
    constructor(id,text,checked){
       this.checked = checked;
       this.id = id;
       this.text = text;
   }
}

class Type {
    value;
    name;
    constructor(name,value){
       this.name = name;
       this.value = value;
   }
}
export default Search;
